import type { ReactNode } from 'react'

import './layout.css'

export interface SettingsSectionProps {
  /** 구역 라벨 (`.sect-t` 445행) */
  title: string
  /**
   * 제목 줄 오른쪽 끝의 단추(「＋ … 추가」 등 · eric 2026-10-28 「추가가 오른쪽에 있잖아」) — 목록 화면의 머리 줄 주 단추와 같은 자리.
   * 안 넘기면 종전 구조 그대로다.
   */
  actions?: ReactNode | undefined
  children: ReactNode
}

/** 설정형 화면의 구역. 구역 사이는 여백으로 가른다(`.acctpg` gap 22px · 443행). */
export function SettingsSection({ title, actions, children }: SettingsSectionProps) {
  return (
    <section className="sect">
      {actions === undefined ? (
        <div className="sect__title">{title}</div>
      ) : (
        <div className="sect__head sect__head--actions">
          <div className="sect__title">{title}</div>
          <div className="sect__actions">{actions}</div>
        </div>
      )}
      {children}
    </section>
  )
}

export interface SettingsRowProps {
  /** 왼쪽 제목 (`.srow2 .sk` 447행) */
  label: string
  /** 가운데 현재 값 */
  value: ReactNode
  /** 오른쪽 「변경」. 누르면 모달이 아니라 **그 자리 드롭다운**이다(§14-2) */
  action?: ReactNode
  /**
   * 「변경」을 눌러 펼친 그 자리 편집 영역. 모달을 쓰지 마라(§1-3 「팝업/모달 남발 금지」).
   * 열려 있을 때만 넘긴다.
   */
  editor?: ReactNode
  /**
   * 값이 한 줄보다 높을 때(그림 등) 라벨을 **위**에 붙인다.
   * 와이어프레임도 챔버 배정 줄에만 `align-items:flex-start` 를 따로 걸었다(2247행).
   * 기본은 가운데 — 한 줄짜리 값에서는 그쪽이 맞다.
   */
  align?: 'center' | 'start'
}

/**
 * 설정형 화면 한 줄 — README §14-2. 「관리 › 일반」과 「내 계정」이 같은 문법을 쓴다.
 * 왼쪽 제목 / 오른쪽 값 + 「변경」. Claude 설정 패턴이다.
 *
 * 설명 문장 슬롯이 없다. 일부러다 — §1-1.
 */
export function SettingsRow({ label, value, action, editor, align }: SettingsRowProps) {
  return (
    <div className="srow">
      <div className={`srow__main${align === 'start' ? ' srow__main--start' : ''}`}>
        <div className="srow__label">{label}</div>
        <div className="srow__value">{value}</div>
        {action ? <div className="srow__action">{action}</div> : null}
      </div>
      {editor ? <div className="srow__editor">{editor}</div> : null}
    </div>
  )
}
